export default (api) => ({
  // Sectores
  fetchSectors: (instanceId, params) => api.$get(`/instances/${instanceId}/sectors`, { params }),

  searchSectors: (instanceId, params) =>
    api.$get(`/instances/${instanceId}/sectors/search`, { params }),

  fetchSector: (id) => api.$get(`/sectors/${id}`),

  createSector: (body) => api.$post("/sectors", body),

  updateSector: (id, body) => api.$patch(`/sectors/${id}`, body),

  deleteSector: (id) => api.$delete(`/sectors/${id}`),

  // Agencias
  fetchAgencies: (sectorId, params) => api.$get(`/sectors/${sectorId}/agencies`, { params }),

  fetchAllAgencies: (instanceId, params) =>
    api.$get(`/instances/${instanceId}/agencies/all`, { params }),

  fetchAgency: (id) => api.$get(`/agencies/${id}`),

  createAgency: (body) => api.$post("/agencies", body),

  updateAgency: (id, body) => api.$patch(`/agencies/${id}`, body),

  deleteAgency: (id) => api.$delete(`/agencies/${id}`),

  // Acciones masivas
  moveAgencies: (instanceId, body) => api.$post(`/instances/${instanceId}/agencies/move`, body),

  updateAllAgents: (instanceId) => api.$post(`/instances/${instanceId}/agencies/updateAgentAll`),

  updateSelectedAgents: (instanceId, body) =>
    api.$post(`/instances/${instanceId}/agencies/updateAgent`, body),

  // Excepciones de vacunas por agencia
  fetchVaccineException: (agencyId, vaccineId) =>
    api.$get(`/agencies/${agencyId}/vaccines/${vaccineId}/exception`),

  updateVaccineException: (agencyId, vaccineId, body) =>
    api.$patch(`/agencies/${agencyId}/vaccines/${vaccineId}/exception`, body),

  // CSV
  prepareCsv: (instanceId, params) =>
    api.$get(`/instances/${instanceId}/agencies/preparecsv`, { params }),

  // Utilidades
  hasLinuxAgents: (agencyId) =>
    api.$get(`/agencies/${agencyId}/agents`, {
      params: { defaultFilter: "osFamily:linux" },
    }),
});
